import { Box } from '@mui/material';
import { WithCookieConsent } from '../cookieConsent/cookieConsentWrapper/cookieConsentWrapper';

export const MapSection = () => (
	<WithCookieConsent
		category="functional"
		title="Google Maps wird blockiert"
		description="Um die Karte anzuzeigen, müssen Sie funktionale Cookies akzeptieren. Diese werden verwendet, um die Google Maps-Integration zu ermöglichen."
	>
		<Box sx={{ width: '100%', height: '100%' }}>
			<Box
				component="iframe"
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.4787502371723!2d7.158070693271778!3d51.53168223627316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b8e146467b6e5d%3A0xcf6ef48beb69d4b5!2sWanner%20Str.%2023%2C%2044649%20Herne!5e1!3m2!1sde!2sde!4v1768933982543!5m2!1sde!2sde"
				width="100%"
				height="100%"
				style={{ border: 0 }}
				allowFullScreen
				loading="lazy"
				referrerPolicy="no-referrer-when-downgrade"
			/>
		</Box>
	</WithCookieConsent>
);